import React from 'react';
import { Typography, Tooltip } from 'antd';

const { Paragraph } = Typography;

const CustomTextWithTooltip = ({
  text,
  level,
  color,
  strong,
  fontSize,
  lineHeight,
  marginBottom,
  marginTop,
  fontWeight,
  textAlign,
  whiteSpace = "nowrap",
  noText = "",
  style = {},
  className
}) => {

  const truncateByLength = (text, maxLength = 23) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  return (
    
      <div
        // style={{
        //   width: "100px",
        //   textOverflow: "ellipsis",
        //   overflow: "hidden",
        //   whiteSpace: "nowrap",
        //   display: "inline-block",
        // }}
      >
        <Paragraph
          className={className}
          level={level}
          strong={strong}
          style={{
            color,
            marginTop,
            fontSize,
            lineHeight,
            fontWeight,
            marginBottom,
            textAlign,
            whiteSpace,
            ...style,
          }}
        >
            <Tooltip title={text}>
          {text ? text : noText}
          </Tooltip>
        </Paragraph>
      </div>
    // </Tooltip>
  );
};

export default CustomTextWithTooltip;
